import axios from 'axios';
import config from '../utils/config';

// Create an Axios instance with default config
const apiClient = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token and JWT secret
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const jwtSecret = localStorage.getItem('jwtSecret');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (jwtSecret) {
      config.headers['X-JWT-Secret'] = jwtSecret;
    }
    
    // Debug request
    console.log(`[API Request] ${config.method.toUpperCase()} ${config.url}`, config);
    
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => {
    // Debug successful response
    console.log(`[API Response] ${response.config.method.toUpperCase()} ${response.config.url}`, response.data);
    
    return response.data;
  },
  (error) => {
    // Debug error response
    console.error(`[API Error] ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });
    
    // Handle rate limiting errors (429)
    if (error.response && error.response.status === 429) {
      error.isRateLimitError = true;
      
      // Extract the custom message from the error response
      if (error.response.data && error.response.data.message) {
        error.rateLimitMessage = error.response.data.message;
      }
    }
    
    // Handle authentication errors
    if (error.response && error.response.status === 401) {
      // Clear authentication and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

// Function to set JWT secret for SDK integration
export const setJwtSecret = (jwtSecret) => {
  if (jwtSecret) {
    localStorage.setItem('jwtSecret', jwtSecret);
    apiClient.defaults.headers['X-JWT-Secret'] = jwtSecret;
  } else {
    localStorage.removeItem('jwtSecret');
    delete apiClient.defaults.headers['X-JWT-Secret'];
  }
};

export default apiClient; 